import styled from "styled-components";

export const AppContainer = styled.div`
    max-width: 1216px;
    margin: auto;
    padding: 14px;
`;